<div [class.shopping] = "showCart" [class.fullShop] = "!showCart">

    <aside [class.asideNormal]="showCart" [class.asideGone]="!showCart">
      <app-cart></app-cart>
    </aside>
    <main [class.mainNormal]="showCart" [class.mainLarge]="!showCart">
      <div class = "categoryButtons">

        <span *ngIf="showCart">
          <div class="arrow">
            <input type="button" class = "switchCartButton" (click)="hideCart()" value={{menuChangeStateButtonText}} />
        </div>
        </span>
        <span *ngIf="!showCart">
          <div class="arrow">
            <input type="button" class = "switchCartButton" (click)="hideCart()" value={{menuChangeStateButtonText}} />
        </div>
        </span>

        <span>
          <div class = "search">

            <input type="button" class="" (click)="resetFilter()" value="Reset Filter" />

          </div>

        </span>

      </div>
        <div class = "categoryHeader">
            <span *ngFor = "let category of categories">
                <input type="button" class="categories" (click)="pickCategory(category.category_name)" value="{{ category.category_name }}" />
            </span>
        </div>

        <div id = "searchBar">
          <input type="text" placeholder="Search by full name" name="search" [(ngModel)] = "searchName"> 
          <input type="button" class ="" (click)="nameFilter(searchName)" value="Search" />
        </div>

        <!-- Shows all products without a filter -->
        <div class = "products">
            <div *ngFor = "let product of products; let i = index">
                    <div class = "product">
                      <img src="{{environment.url}}/{{product.image}}"  width="80%" height="80%">
                        <br>
                        Name: {{ product.product_name }}
                        <br>
                        Price: {{ product.price }}
                        <br>
                        <button class="btn btn-outline-dark" [disabled]="disableButton[i]" (click)="open(content)">Add to cart</button>
        <ng-template #content let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Order product</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              Amount: <input type="button" class="" (click)="decreaseAmount(i)" value="-" /> {{ amount[i] }} <input
                type="button" class="" (click)="increaseAmount(i)" value="+" />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-dark"
              (click)="save(i, product.product_name, product.price, amount[i])">Order</button>
          </div>
        </ng-template>
                        <br>
                    </div>

            </div>
        </div>     
    </main>

  </div>